<template>
  <component
    :is="isDesktop ? 'div' : 'c-modal'"
    name="search-container"
    class="search-container"
    v-bind="$attrs"
    :is-fullscreen="false"
    @close="$listeners['close']"
  >
    <c-modal-mask
      transparent
      :show="isMaskOpened"
      @close="openResults = false"
    />

    <search-field
      class="field"
      :term="term"
      @click.native="clickInput"
      @input="updateInput"
      @submit="$listeners['submit-term']"
      @close="openResults = false"
      v-on="$listeners"
    />

    <search-suggestions
      v-if="isSuggestionsOpened"
      class="results"
      :results="results"
      v-bind="$attrs"
      @click-suggestion="clickSuggestion"
    />
  </component>
</template>

<script>
import SearchField from '@components/Search/SearchField'
import SearchSuggestions from '@components/Search/SearchSuggestions'

export default {
  components: { SearchField, SearchSuggestions },

  props: {
    term: String,
    results: Array
  },

  data () {
    return {
      openResults: false
    }
  },

  computed: {
    isMaskOpened () {
      return !!(this.isDesktop && this.openResults && this.results.length && this.term)
    },

    isSuggestionsOpened () {
      return !!(this.term && this.results.length && this.openResults)
    }
  },

  methods: {
    clickSuggestion (data) {
      window.dataLayer.push({
        event: 'Resultados clicados',
        nome_parceiro: data.partner_name,
        slug_titulo_oferta: data.slug
      })

      this.openResults = false
      this.$emit('click-suggestion', data)
    },

    clickInput () {
      this.openResults = true
      this.$emit('update-term', this.term)
    },

    updateInput (value) {
      this.openResults = true
      this.$emit('update-term', value)
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$c-modal-button-size: 70px;
$search-container-size: auto $c-modal-button-size;

.search-container {
  &.c-modal {
    padding: 0;
    .close {
      margin: 15px 10px;
    }
    }

  & > .content {
    & > .field {
      @include size($search-container-size);
      margin-right: $c-modal-button-size;
      margin-left: 10px;
    }
  }

  @include desktop {
    & > .search-suggestions.results {
      width: 400px;
      background-color: $white-color;
      transform: translateY(0);
    }

    & > .field,
    & > .results {
      z-index: 5;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/SearchContainer.vue